const style = {
  button__icon: {
    position: 'relative',
    top: '-1px',
    left: '-1px',
  },
};

export default style;
